import Keyb from "keyb"
import Joyp from "joyp"

import Random from "@frog/source/utility/Random.js"

import App from "@frog/source/models/App.js"
import Dev from "@frog/source/models/dev/Dev.js"
import Stage from "@frog/source/models/Stage.js"
import Unit from "@frog/source/models/Unit.js"
import Zone from "@frog/source/models/Zone.js"
import Selection from "@frog/source/models/Selection.js"
import Step from "@frog/source/models/Step.js"
import Delta from "@frog/source/models/Delta.js"

import Audiomix from "@frog/source/engine/Audiomix.js"
import Navigation from "@frog/source/engine/navigating/Navigation.js"

import games from "@frog/source/data/games/index.js"

import {nanoid} from "nanoid"
import querystring from "query-string"

export default class Chapter {
    static load(proto, options) {
        options = options || {}

        const chapter = new Chapter()
        chapter.type = "combat"
        chapter.player = proto.player || {"affiliation": "good"}
        chapter.slug = proto.chapter.slug
        chapter.gameslug = proto.gameslug
        chapter.images = proto.chapter.images
        chapter.audio = proto.chapter.audio
        chapter.hasTutorial = proto.chapter.hasTutorial
        chapter.hasPreparePhase = proto.chapter.hasPreparePhase
        chapter.hasUndoEndTurnButtons = proto.chapter.hasUndoEndTurnButtons
        chapter.hasAutoEnd = proto.chapter.hasAutoEnd
        chapter.isRandomized = proto.chapter.isRandomized
        chapter.timer = 5 * 60 * 1000

        chapter.decorations = proto.chapter.decorations || {}

        if(chapter.audio != undefined) {
            if(chapter.audio instanceof Array != true) {
                Audiomix.trigger(chapter.audio)
            } else {
                chapter.audio.forEach((audio) => {
                    Audiomix.trigger(audio)
                })
            }
        }

        chapter.encounters = proto.chapter.encounters

        chapter.random = new Random()
        const query = querystring.parse(window.location.search)
        const seed = query.seed || proto.randomSeed || nanoid()
        chapter.random.setSeed(seed)
        chapter.originalSeed = seed
        chapter.animationSequence = options.animationSequence
        chapter.runningDeltastageSum = {}
        chapter.runningDeltastageSubsum = {}

        // chapter.events = proto.chapter.events
        chapter.stage = Stage.load({
            "stage": proto.chapter.stage,
            "player": proto.player,
            "chapterParty": proto.chapterParty,
            "hasPreparePhase": chapter.hasPreparePhase,
            "startingEncounter": proto.startingEncounterKey || proto.chapter.startingEncounter,
            "chapterSlug": chapter.slug,
            "gameSlug": chapter.gameslug,
            "random": chapter.random,
        })
        if(proto.chapter.stage != undefined
        && options.isBlockingSideEffects != true) {
            Dev.loadedProtostage = proto.chapter.stage
            Object.values(Dev.loadedProtostage.units).forEach((unit) => {
                Dev.cacheUnitReferredProperties({unit, "player": chapter.player, "chapterSlug": chapter.slug, "gameSlug":  chapter.gameslug})
            })
        }
        // let that = chapter
        // for(let key in that) {
        //     this[key] = that[key]
        // }

        chapter.previousStages = []

        chapter.actionTrace = []
        if(options.isBlockingSideEffects != true) {
            chapter.sequence = {
                "steps": []
                // .concat(Stage.getEventSteps(chapter.stage, "turn:0:start"))
                // .concat(Stage.getEventSteps(chapter.stage, "turn:every:start"))
                // .concat(Stage.getEventSteps(chapter.stage, "turn:every-even:start"))
            }
            if(chapter.sequence.steps != undefined
            && chapter.sequence.steps.length > 0) {
                chapter.sumSteps(chapter.sequence.steps)
                chapter.stage = chapter.sequence.steps[chapter.sequence.steps.length - 1].omegastage
            }
        }

        if(chapter.hasPreparePhase == true) {
            chapter.startPreparePhase()
        } else {
            chapter.startPlayPhase()
        }

        chapter.selection = new Selection({"chapter": chapter})

        return chapter
    }
    get sequence() {
        if(this.animationSequence != undefined) return this.animationSequence
        return App.sequence
    }
    set sequence(sequence) {
        if(this.animationSequence != undefined) {
            this.animationSequence = sequence
        } else {
            App.sequence = sequence
        }
    }
    startPreparePhase() {
        this.phase = "prepare"
    }
    startPlayPhase({dialogue} = {}) {
        this.phase = "play"

        let steps = []
            .concat(Stage.getEventSteps(this.stage, "chapter:start"))
            .concat(Stage.getEventSteps(this.stage, "turn:0:start"))
            .concat(Stage.getEventSteps(this.stage, "turn:every:start"))
            .concat(Stage.getEventSteps(this.stage, "turn:every-even:start"))

        if(steps.length > 0) {
            this.stage = steps.filter((step) => step.name != "SavestateCapture").pop()?.omegastage
            this.sequence = {"steps": steps}
            this.sumSteps(steps)
        }

        Stage.calculateActions(this.stage)
    }
    update(delta) {
        this.selection.update(delta)

        if(Dev.inProtoMode == false) {
            if(Keyb.wasJustPressed("Z")
            || Joyp.wasJustPressed(0, "left-bumper", delta.ms)
            || Joyp.wasJustPressed(0, "right-bumper", delta.ms)) {
                this.actionTrace.push({"type": "undoAction"})
                this.undoAction()
                Dev.recordSavestate("livePlaytest")
            }
        }

        if(Keyb.isPressed("<control>") && Keyb.isPressed("R")) {
            App.game.chapter.restart()
        }

        const stage = App.getActiveStage()
        if(stage?.turn.affiliation === "good") {
            if(stage.player.timeout - this.timer > 0) {
                this.timer += Math.min(delta.ms, 100)
                if(stage.player.timeout - this.timer <= 0) {
                    this.endPlayerTurn()
                }
                // console.log(stage.phase)
                if(stage.player.phase == "ritual"
                && Audiomix.getActiveTriggerByLabel("music")?.key != "Music:4") {
                    Audiomix.trigger("Music:4")
                }
                if(stage.player.phase == "observe"
                && Audiomix.getActiveTriggerByLabel("music")?.key != "Music:1") {
                    Audiomix.trigger("Music:1")
                }
            }
        }
    }
    setStage(stage) {
        this.stage.runningDeltastageSum = Delta.copyDeltastageSum(this.runningDeltastageSum)
        this.previousStages.push(this.stage)
        if(this.previousStages.length > 10) {
            this.previousStages.shift()
        }

        this.stage = stage
    }
    clearPreviousStages() {
        this.previousStages = []
    }
    reloadStage(options) {
        options = options || {}
        let protogame = games[this.gameslug]
        let protochapter = protogame.chapters[this.slug]
        this.stage = Stage.load({
            "stage": protochapter.stage,
            "player": options.player || protogame.player,
            "chapterParty": protogame.chapterParty,
            "hasPreparePhase": protochapter.hasPreparePhase,
            "startingEncounter": this.stage.currentEncounterKey,
            "random": this.random,
        })
        this.recalculateStage()
        this.actionTrace = []
        this.runningDeltastageSum = {}
    }

    replaySavestateFromActiontrace(savestate, options) {
        options = options || {}

        for (const savedSelection of savestate.actionTrace) {
            if(savedSelection.type == "endTurn") {
                this.runningDeltastageSubsum = {}
                this.endPlayerTurn(this.stage, {"isAutocapturingSavestates": false, "seed": savedSelection.seed})

                // const deltaDiff = Delta.diffDeltastageSums(savedSelection.deltastageSum, this.runningDeltastageSubsum)
                // if(Object.values(deltaDiff).length > 0) {
                //     // console.warn("Savestate replay diverges at this action. Terminating replay at this point", savedSelection, deltaDiff)
                //     // // is blasted too many times, even when not in dev mode.
                //     return
                // }
                continue
            }
            if(savedSelection.type == "endEncounter") {
                this.runningDeltastageSubsum = {}
                this.endPlayerTurn(this.stage, {"isAutocapturingSavestates": false, "seed": savedSelection.seed})
                const steps = Stage.processEventSteps(stage, condition.events)
                this.sequence.steps = this.sequence.steps.concat(steps)
                stage = steps[steps.length - 1].omegastage
                Stage.calculateActions(stage)
                this.stage = stage
                this.sumSteps(steps)

                const deltaDiff = Delta.diffDeltastageSums(savedSelection.deltastageSum, this.runningDeltastageSubsum)
                if(Object.values(deltaDiff).length > 0) {
                    console.warn("Savestate replay diverges at this action. Terminating replay at this point", savedSelection, deltaDiff)
                    return
                }
                continue
            }
            if(savedSelection.type == "undoAction") {
                this.undoAction()
                continue
            }
            if(savedSelection.type == "killAllEnemies") {
                this.killAllEnemies()
                continue
            }

            const unit = this.stage.units[savedSelection.performerKey]
            if(unit == undefined) {
                console.warn("Terminating savestate replay. This saved action's performer no longer exists: ", savedSelection)
                this.selection.hoveredAction = savedSelection
                break
            }
            unit.actionmap = Unit.calculateActions(unit.key, this.stage)
            const actionlist = unit.actionmap[savedSelection.position.x + "x" + savedSelection.position.y]
            if(actionlist == undefined) {
                console.warn("Terminating savestate replay. This saved action's position no longer has any actions: ", savedSelection)
                this.selection.hoveredAction = savedSelection
                this.selection.selectedUnitKey = savedSelection.performerKey
                break
            }
            const subactionlist = this.selection.findSubactionsInActionlist({unit, actionlist, "options": {}})
            const indexedAction = subactionlist.filter((action) => {
                return action.type == savedSelection.type
                    && action.skillKey == savedSelection.skillKey
                    && action.omegastage.units[action.performerKey].position.x == savedSelection.performerPosition.x
                    && action.omegastage.units[action.performerKey].position.y == savedSelection.performerPosition.y
            })[0]
            if(indexedAction == undefined) {
                console.warn("Terminating savestate replay. This saved action no longer available: ", savedSelection)
                this.selection.hoveredAction = savedSelection
                this.selection.selectedUnitKey = savedSelection.performerKey
                break
            }

            if(options.isShowingEveryStep == true) {
                this.sequence = {"steps": (this.sequence?.steps || []).concat(indexedAction.steps)}
            } else {
                this.sequence = {"steps": indexedAction.steps}
            }
            this.setStage(indexedAction.omegastage)
            const replayDelta = this.sumSteps(indexedAction.steps)
            const savedDelta = savedSelection.deltastageSum
            const deltaDiff = Delta.diffDeltastageSums(savedDelta, replayDelta)
            if(Object.values(deltaDiff).length > 0) {
                console.warn("Savestate replay diverges at this action. Terminating replay at this point", savedSelection, deltaDiff)
                return
            }
        }
        if(options.isShowingEveryStep == true) {
            return
        }
        if(savestate.sequenceLengthRemaining == undefined) {
            this.sequence = undefined
        } else {
            const newLength = savestate.sequenceLengthRemaining
            if(this.sequence == undefined) {
                console.warn("Savestate replay error: Replay has no animated sequence to show")
                return
            }
            if(this.sequence.steps.length < newLength) {
                console.warn("Savestate replay error: Replay's animation sequence length does not match")
                return
            }
            this.sequence.steps = this.sequence.steps.slice(this.sequence.steps.length - newLength, this.sequence.steps.length)
        }
    }
    sumSteps(steps) {
        const subsum = {}
        steps.forEach((step) => {
            if(step.name == "SavestateCapture") return
            if(step.deltastages.length > 0) {
                Delta.addDeltastages(subsum, step.deltastages)
            }
        })
        Delta.addDeltastages(this.runningDeltastageSubsum, subsum)
        Delta.addDeltastages(this.runningDeltastageSum, subsum)
        return subsum
    }
    killAllEnemies() {
        this.saveStage()

        let currentZone = this.stage.encounters[this.stage.currentEncounterKey]
        const alliedUnits = Object.values(this.stage.units).filter((unit) => {
            return Zone.isInBounds(currentZone, unit.position)
                && unit.affiliation == this.stage.player.affiliation
        })
        const enemyUnits = Object.values(this.stage.units).filter((unit) => {
            if(Zone.isInBounds(currentZone, unit.position)) {
                if(unit.affiliation != this.stage.player.affiliation) {
                    return true
                }
            }
            return false
        })

        const EXPERIENCE_PER_KILL = 20
        const step = Step.instantiate({
            "alphastage": this.stage,
            "deltastages": enemyUnits.map((unit, index) => {
                const slayerUnit = alliedUnits[0]
                alliedUnits.unshift(alliedUnits.pop())

                unit.health = 0
                unit.isDead = true
                alliedUnits[0].experience += EXPERIENCE_PER_KILL

                return {
                    "stage": {
                        "units": [
                            {
                                "key": unit.key,
                                "isDead": true,
                                "health": 0,
                            },
                            {
                                "key": slayerUnit.key,
                                "experience": slayerUnit.experience + EXPERIENCE_PER_KILL,
                            }
                        ]
                    }
                }
            })
        })
        this.sequence = {"steps": [step]}
        Stage.calculateActions(step.omegastage)
        this.setStage(step.omegastage)

        this.recalculateStage()
        this.sumSteps([step])

        Navigation.state.escape = undefined
    }
    undoAction() {
        if(this.previousStages.length > 0) {
            const poppedStage = this.previousStages.pop()
            this.runningDeltastageSum = poppedStage.runningDeltastageSum
            this.stage = poppedStage

            // If we are also recording the
            // actions for a test snapshot, then
            // make sure we undo here as well.
            // TODO: read the protoactions from
            // our previousStages list?
            if(window.frog != undefined
            && window.frog.test != undefined
            && window.frog.test.snapshot != undefined) {
                window.frog.test.snapshot.protoactions.pop()

                // TODO: What happens if we undo before
                // the snapshot.alphastage? All following
                // protoactions wouldn't make any sense.
            }

            Audiomix.trigger("UndoAction")
            // if(this.selection.canSelect(this.selection.selectedUnitKey, this.stage) == false) {
            //     this.selection.reset()
            // }
            this.selection.reset()

            this.sequence = undefined
        }
    }
    performAction(action) {
        // if(window.frog != undefined
        // && window.frog.test != undefined
        // && window.frog.test.snapshot != undefined) {
        //     window.frog.test.snapshot.protoactions.push({
        //         "unitKey": action.performerKey,
        //         "position": Geometry.copy(action.position),
        //         "actionKey": action.key,
        //     })
        // }

        this.sequence = {"steps": action.steps}
        action.steps.push({
            "deltastages": [],
            "omegastage": action.omegastage,
            "func": function() {
                Stage.calculateActions(action.omegastage)
            }
        })
        // Stage.calculateActions(action.omegastage) // this lags - needs to be in other thread!!!
        // action.omegastage.steps = steps
        this.setStage(action.omegastage)

        // Auto-finishing
        if(this.hasAutoEnd === true
        || this.hasUndoEndTurnButtons === false) {
            const hasFinishedTurn = Object.values(action.omegastage.units).filter((unit) => {
                if(unit.affiliation != App.game.chapter.stage.player.affiliation) return false
                if(unit.isDead == true) return false
                if(unit.isRemoved == true) return false
                if(Zone.isOutOfBounds(action.alphastage.encounters[action.alphastage.currentEncounterKey].zone, unit.position)) return false
                // if(unit.subclasses != undefined) {
                //     return unit.energy[1] != false
                //         || unit.energy[2] != false
                // } else {
                //     return unit.energy[1] != false
                // }
                if(unit.energy["invoke skill"] == false
                && unit.energy["move"] == false) {
                    return false
                }
                return true
            }).length == 0
            if(hasFinishedTurn == true) {
                return this.endPlayerTurn(action.omegastage)
            }
        }

        return action.omegastage
    }
    saveStage() {
        const omegastage = Stage.copy(this.stage)
        omegastage.steps = []
        this.setStage(omegastage)
    }
    recalculateStage() {
        Stage.calculateActions(this.stage, {"force": true})
    }
    endPlayerTurn(stage, options) {
        stage = stage || this.stage
        options = options || {}

        Audiomix.trigger("EndTurn")

        // if(stage.turn.affiliation != this.player.affiliation) {
        //     return console.error("not currently player turn.")
        // }

        this.selection.reset()
        const seed = options.seed || nanoid()
        this.random.setSeed(seed)

        // And now.. perform the next turn!!

        if(stage.nextTurn == undefined) {
            Stage.calculateNextTurn(stage)
        }

        const steps = stage.nextTurn.steps
        this.sequence = {"steps": (this.sequence?.steps || []).concat(steps)}

        const omegastage = steps[steps.length - 1].omegastage
        omegastage.steps = steps
        Stage.calculateActions(omegastage || this.stage)
        this.setStage(omegastage)
        this.clearPreviousStages()

        options.isAutocapturingSavestates = options.isAutocapturingSavestates || true
        if(options.isAutocapturingSavestates == true) {
            steps.forEach((step) => {
                if(step.name == "SavestateCapture") {
                    Dev.recordSavestate(step.savestateSlug, step.data)
                }
            })
        }
        this.sumSteps(stage.nextTurn.steps)
        if(options.isAutocapturingSavestates == true) {
            Dev.recordSavestate("livePlaytest")
        }

        return omegastage
    }
    restart(options) {
        options = options || {}
        this.actionTrace = []
        this.runningDeltastageSum = {}
        App.load({
            "game": {
                "slug": this.gameslug,
                "player": options.player || App.game.player,
                "chapter": games[this.gameslug].chapters[App.game.chapter.slug],
                "configuration": games[this.gameslug].configuration,
                "randomSeed": options.randomSeed,
                "audio": games[this.gameslug].audio, // TODO: THIS IS A MAJOR BUG!! WE SHOULD BE COPYING OVER ALL PROPERTIES FROM GAME!!
            }
        })
    }
}
